import { Injectable } from '@angular/core'

import {
  OpenRegistrationFilterOption,
  OpenRegistrationFilters,
} from '../open-registration-filter/open-registration-filter.component'

export type RegistrationPageFilterTab = 'open' | 'completed'

export interface RegistrationPageOpenFilterOptions {
  organizations: OpenRegistrationFilterOption[]
  signupTypeList: OpenRegistrationFilterOption[]
  sports: OpenRegistrationFilterOption[]
}

@Injectable({
  providedIn: 'root',
})
export class RegistrationPageFilterStateService {
  private readonly filtersByTab: Record<RegistrationPageFilterTab, OpenRegistrationFilters> = {
    completed: this.emptyFilters(),
    open: this.emptyFilters(),
  }
  private openFilterOptions = this.emptyOpenFilterOptions()
  private openFilterOptionsSaved = false

  public filtersFor(tab: RegistrationPageFilterTab): OpenRegistrationFilters {
    return this.cloneFilters(this.filtersByTab[tab])
  }

  public saveFilters(tab: RegistrationPageFilterTab, filters: OpenRegistrationFilters): void {
    this.filtersByTab[tab] = this.cloneFilters(filters)
  }

  public clearFilters(tab: RegistrationPageFilterTab): void {
    this.filtersByTab[tab] = this.emptyFilters()
  }

  public clearAll(): void {
    this.clearFilters('open')
    this.clearFilters('completed')
    this.clearOpenFilterOptions()
  }

  public hasOpenFilterOptions(): boolean {
    return this.openFilterOptionsSaved
  }

  public openOptions(): RegistrationPageOpenFilterOptions {
    return this.cloneOpenFilterOptions(this.openFilterOptions)
  }

  public saveOpenOptions(options: RegistrationPageOpenFilterOptions): void {
    this.openFilterOptions = this.cloneOpenFilterOptions(options)
    this.openFilterOptionsSaved = true
  }

  public clearOpenFilterOptions(): void {
    this.openFilterOptions = this.emptyOpenFilterOptions()
    this.openFilterOptionsSaved = false
  }

  public cloneFilters(filters?: OpenRegistrationFilters): OpenRegistrationFilters {
    return {
      organization: [...(filters?.organization || [])],
      person: [...(filters?.person || [])],
      sport: [...(filters?.sport || [])],
      type: [...(filters?.type || [])],
    }
  }

  public emptyFilters(): OpenRegistrationFilters {
    return {
      organization: [],
      person: [],
      sport: [],
      type: [],
    }
  }

  private cloneOpenFilterOptions(options: RegistrationPageOpenFilterOptions): RegistrationPageOpenFilterOptions {
    return {
      organizations: this.cloneOptions(options.organizations),
      signupTypeList: this.cloneOptions(options.signupTypeList),
      sports: this.cloneOptions(options.sports),
    }
  }

  private cloneOptions(options: OpenRegistrationFilterOption[]): OpenRegistrationFilterOption[] {
    return options.map((option) => ({ ...option }))
  }

  private emptyOpenFilterOptions(): RegistrationPageOpenFilterOptions {
    return {
      organizations: [],
      signupTypeList: [],
      sports: [],
    }
  }
}
